import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import "./style.css";

const titleOptions = [
  "Butuh Bantuan Bayar?",
  "Promo Tinggal Sebentar Lagi!",
  "Tinggal Selangkah Lagi!",
  "Butuh Bantuan?",
  "Masih Ragu?",
  "Masih Galau?",
];

const getRandomItem = (arr) => arr[Math.floor(Math.random() * arr.length)];

const getDescOptions = (productName, isHosting = false, isDomain = false) => {
  const displayName = isDomain ? `domain ${productName}` : productName;
  
  const baseOptions = [
    `Perlu panduan bayar <b>${displayName}</b>? Langsung chat aja!`,
    `Tanya keraguanmu tentang <b>${displayName}</b> ke tim kami, langsung dijawab saat ini juga!`,
    `Kami lihat kamu lagi prosesin <b>${displayName}</b>, kalau ada kesulitan saat pembayaran, kami bisa bantu step by step.`,
    `Masih proses <b>${displayName}</b>? Hubungi kami jika kamu mengalami kendala, ya!`, 
    `Ada kendala pembayaran <b>${displayName}</b>? Kami siap bantu kamu step by step!`, 
    `Hubungi kami jika ada kendala pembayaran <b>${displayName}</b> disini!`
  ];

  if (isHosting) {
    return [
      `Promo untuk <b>${displayName}</b> hampir habis nih! , Butuh bantuan bayar sekarang? Kami standby bantuin kamu langsung.`,
      `Jangan lewatkan promo <b>${displayName}</b> ini. Tim kami siap bantu sekarang juga!`,
      ...baseOptions
    ];
  }

  return baseOptions;
};

const btnOptions = [
  "Klik untuk Chat!",
  "Klik untuk Bantuan!",
  "Tanya di Sini!",
];

const BubbleChat = ({ onClick, productsList = [] }) => {
  const location = useLocation();
  const [showBubble, setShowBubble] = useState(false); // Kontrol tampil/tidak tampil BubbleChat
  const [showPromo, setShowPromo] = useState(false); // Kontrol tampil dots vs content
  const [randomTitle, setRandomTitle] = useState(titleOptions[0]);
  const [randomDesc, setRandomDesc] = useState("");
  const [randomBtn, setRandomBtn] = useState(btnOptions[0]);
  const [closed, setClosed] = useState(false);

  useEffect(() => {
    if (productsList.length > 0) {
      setShowBubble(false);
      setShowPromo(false);
      setClosed(false);
      
      // Timer pertama: 1 menit untuk mulai tampil dots
      const initialTimer = setTimeout(() => {
        setShowBubble(true);
        
        // Timer kedua: 3 detik setelah dots tampil, baru tampil content
        const contentTimer = setTimeout(() => {
          setShowPromo(true);
          
          // Set random content saat content tampil
      setRandomTitle(getRandomItem(titleOptions));
      
      const hasHostingOrVPS = productsList.some(product => 
        product.type === 'hostingaccount' || product.type === 'server'
      );

      const isDomain = productsList.some(product => 
        product.type === 'register' || product.type === 'transfer'
      );

      const productName = productsList.find(product => 
        hasHostingOrVPS 
          ? (product.type === 'hostingaccount' || product.type === 'server')
          : (product.type !== 'hostingaccount' && product.type !== 'server')
      )?.name || 'produk';
      
      const descOptions = getDescOptions(productName, hasHostingOrVPS, isDomain);
      setRandomDesc(getRandomItem(descOptions));
      setRandomBtn(getRandomItem(btnOptions));
        }, 3000); // 3 detik untuk animasi dots
        
        return () => clearTimeout(contentTimer);
      }, 60000); // 1 menit = 60000ms
      
      return () => clearTimeout(initialTimer);
    }
  }, [productsList]);

  if (location.pathname === "/paymentmethod" || location.pathname === "/ordersummary") return null;
  if (productsList.length === 0 || closed || !showBubble) return null;

  // const handleChatClick = () => {
  //   if (window.openChat) {
  //     window.openChat();
  //   } else {
  //     const btn = document.getElementById('btnOpenChat');
  //     if (btn) btn.click();
  //   }
  //   if (onClick) onClick();
  // };

  return (
    <>
      {!showPromo ? (
        <div className="bubble-chat-container">
          <div className="dot-content">
            <div className="bubble-chat-dots">
              <span className="dot dot1"></span>
              <span className="dot dot2"></span>
              <span className="dot dot3"></span>
            </div>
          </div>
        </div>
      ) : (
        <div className="bubble-chat-container">
          <div className="bubble-chat-content">
            <div className="bubble-chat-title">
              <span className="bubble-chat-bell">
                <svg width="28" height="28" viewBox="0 0 24 24" fill="white">
                  <path d="M12 2C10.067 2 8.5 3.567 8.5 5.5V6.09C6.06 7.165 4.5 9.432 4.5 12V17L3 18.5V19H21V18.5L19.5 17V12C19.5 9.432 17.94 7.165 15.5 6.09V5.5C15.5 3.567 13.933 2 12 2ZM12 22C13.1046 22 14 21.1046 14 20H10C10 21.1046 10.8954 22 12 22Z" />
                </svg>
                <span className="bubble-chat-badge">1</span>
              </span>
              <span className="bubble-chat-title-text">{randomTitle}</span>
              <button className="bubble-chat-close" onClick={() => setClosed(true)} aria-label="Tutup">×</button>
            </div>
            <div className="bubble-chat-desc" dangerouslySetInnerHTML={{ __html: randomDesc }} />
            {/* <button className="bubble-chat-btn" onClick={handleChatClick}>
              {randomBtn}
            </button> */}
          </div>
        </div>
      )}
    </>
  );
};

export default BubbleChat;
